/* eslint-disable import/prefer-default-export */
import DOMPurify from 'dompurify'

export function sanitizeSVG(svgString: string) {
  return DOMPurify.sanitize(svgString, { USE_PROFILES: { svg: true } })
}
